import { useEffect } from "react";

import Field from "../field";
import { getPositiveInteger } from "../utils";

export default function EditPracticalsCount({
  practicalsCount,
  setPracticalsCount,
  setPracticals,
}) {
  useEffect(() => {
    setPracticals((prev) => {
      if (prev.length === practicalsCount) {
        return prev;
      }

      if (practicalsCount > prev.length) {
        return prev.concat(
          Array.from({ length: practicalsCount - prev.length }, (_, index) => ({
            number: prev.length + index + 1,
            variantsCount: 1,
            startDate: "",
            endDate: "",
          })),
        );
      }
      return prev.slice(0, practicalsCount);
    });
  }, [practicalsCount]);

  return (
    <Field label="Количество практических работ" required>
      <input
        type="number"
        min="1"
        value={practicalsCount}
        onChange={(e) => setPracticalsCount(getPositiveInteger(e.target.value))}
      />
    </Field>
  );
}
